import Notification from "../components/token/Notification";
import toast, { Toast } from "react-hot-toast";

// Define the shape of the notify function's parameters
interface NotifyOptions {
  isSuccess: boolean;
  message: string;
  info?: string;
  list?: string[];
}

// The notify function displays a custom toast notification using the Notification component
export function notify({
  isSuccess,
  message,
  info,
  list = [],
}: NotifyOptions): void {
  toast.custom((t: Toast) => (
    <Notification
      t={t}
      isSuccess={isSuccess}
      message={message}
      info={info}
    />
  ));
}
